import React from "react";

import { SearchComponentOfType } from "@utils/search/@types/searchComponent";

import { useSearchComponentStateSelector } from "@redux/modules/value/search/search.selectors";

import { DelegatingFacet } from "@components/Search/SearchResults/StateComponents/Facets/Facet/delegatingFacet.container";

import { filterFacets } from "./facet.filters";

type FacetsProps = {
    component: SearchComponentOfType<"FACETS">;
};

const Facets = ({ component }: FacetsProps) => {
    const facetsComponentState = useSearchComponentStateSelector(component);

    if (!facetsComponentState?.facets?.length) return null;

    return (
        <>
            {facetsComponentState.facets
                .filter(filterFacets)
                .sort((a, b) => a.order - b.order)
                .map(facet => (
                    <DelegatingFacet
                        key={facet.name + facet.order}
                        facet={facet}
                        component={component}
                    />
                ))}
        </>
    );
};

export { Facets };
